import type { FieldError } from "react-hook-form";
import { cn } from "../../lib/utils";
import { type RadioCardOption, RadioCardSelect } from "../../patterns/radio-select";
import { FormFieldError } from "../FormFieldError";

export type RadioCardSelectInputProps<TValue extends string | number | boolean> = {
	value?: TValue | null;
	onChange?: (value: TValue) => void;
	onBlur?: () => void;
	options: RadioCardOption<TValue>[];
	direction?: "row" | "column";
	gap?: "sm" | "md" | "lg";
	error?: FieldError;
	errorMessage?: string;
	disabled?: boolean;
	className?: string;
	testId?: string;
};

export const RadioCardSelectInput = <TValue extends string | number | boolean = string>({
	value,
	onChange,
	onBlur,
	options,
	direction,
	gap,
	error,
	errorMessage,
	disabled,
	className,
	testId,
}: RadioCardSelectInputProps<TValue>) => {
	return (
		<div className="relative w-fit">
			<RadioCardSelect<TValue>
				value={value ?? null}
				onChange={(next) => {
					onChange?.(next);
					onBlur?.();
				}}
				options={options}
				direction={direction}
				gap={gap}
				disabled={disabled}
				className={cn(
					className,
					error
						? "outline outline-danger hover:outline-danger-hover outline-offset-[6px] rounded-md"
						: undefined,
				)}
				testId={testId}
			/>
			<FormFieldError
				error={error}
				errorMessage={errorMessage}
				className={cn("top-[-16px] left-[-8px]")}
			/>
		</div>
	);
};
